export const ScheduleTaskTypes = {
  RateARisk: 'rate_a_risk',
  TestAControl: 'test_a_control',
} as const;
export type ScheduleTaskType =
  (typeof ScheduleTaskTypes)[keyof typeof ScheduleTaskTypes];
